/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMath = createReactComponent("math", "IconMath", [
  ["path", { d: "M19 5h-7l-4 14l-3 -6h-2", key: "svg-0" }],
  ["path", { d: "M14 13l6 6", key: "svg-1" }],
  ["path", { d: "M14 19l6 -6", key: "svg-2" }]
]);

export { IconMath as default };
//# sourceMappingURL=IconMath.js.map
